import React from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import '../Dashboard.css'
import { NoData } from './NoData';

export function Engagement() {
  const rows:any[] = [1,2,3,4,5];

  return (
    <div className='Dcard Dengagement'>
      <h2 className='Dheading'>Top Influencers by Eng. Rate</h2>
      {rows.length===0 ? (
        <NoData />
      ) : (
        <div className='table-responsive'>
          <table className="table table-row-dashed table-row align-middle gs-0 gy-4 m-0">
            <thead>
              <tr className='fw-bolder text-muted'>
                <th style={{width: "350px"}}>
                  <span className='d-flex'>Influencers</span>
                </th>
                <th style={{width: "100px"}}>
                  <span className='d-flex'>Platform</span>
                </th>
                <th>
                  <span className='d-flex' style={{width: "60px"}}>Eng Rate</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((index) => (
                <tr key={index} className=''>
                  <td className='fw-bolder'>
                    <img className='Davatar' src={toAbsoluteUrl('/media/avatars/150-4.jpg')} alt='' />
                    Abhinav Mukherjee
                  </td>
                  <td className='fw-normal'>
                    <img src={toAbsoluteUrl('/media/logos/Instagram.png')}  alt='' />
                  </td>
                  <td className='fw-bolder'>
                    68%
                  </td>      
                </tr>
              ))}
            </tbody>
          </table> 
        </div>
      )}
    </div>         
  )
}